export const QK = {
    FAVORITE_FILTERS: {
        ALL: 'favorite-filters',
        POST: 'post-favorite-filter',
        DELETE: 'delete-favorite-filter',
        GET: 'get-favorite-filter',
    },
    FILTER: {
        CUSTOM_DATA_VALUES: 'filter-custom-data-values',
    },
    INTERACTIONS: {
        TABLE: 'interactions-table',
        GET: 'get-interactions',
        COUNT: 'interactions-count',
    },
    ACCOUNT: {
        GET: 'get-my-account',
    },
    COACHING_FORMS: {
        GET: 'get-coaching-forms',
    },
    COACHING_FORM: {
        GET: 'get-coaching-form',
        DELETE: 'delete-coaching-form',
        CREATE: 'create-coaching-form',
        UPDATE: 'update-coaching-form',
        PROTOCOLS_USAGE: 'coaching-form-protocols-usage',
        COPY: 'copy-coaching-form',
    },
    SCHEDULE_COACHING_FORMS: {
        SCHEDULE: 'schedule-coaching-form',
        GET: 'get-schedule-coaching-forms',
    },
    PROTOCOL: {
        GET: 'get-protocol',
        TABLE: 'protocol-table',
        COACHABLE_AGENTS: 'coachable-agents',
        COUNT: 'protocol-count',
    },
    SHARE_DASHBOARD: {
        USERS: 'share-dashboard-users',
        ROLES: 'share-dashboard-roles',
    },
    USERS: {
        SEARCH: 'users-search',
        DETAILED: 'get-user-detailed',
    },
    ORGANISATIONAL_RESULTS: {
        TABLE: 'organisational-results-table',
    },
    CHANNEL: {
        ALL: 'get-channels',
    },
    ROLES: {
        ALL: 'roles-all',
        GET: 'get-role',
        PERMISSIONS: 'get-role-permissions',
    },
    WIDGET_PREVIEW: {
        GET: 'widget-preview',
    },
    AGENT_ANONYMIZATION: {
        WAITING_FOR_APPROVAL: 'agent-anonymization-waiting-for-approval',
        APPROVED: 'agent-anonymization-approved',
        ANONYMIZED: 'agent-anonymization-anonymized',
    },
    BACK_OFFICE: {
        TENANTS: 'back-office-tenants',
        TENANT: 'back-office-tenant',
        UNMIGRATED_COMPANIES: 'back-office-active-nonimported-companies',
        UNMIGRATED_EXTERNAL_SYSTEMS: 'back-office-active-nonimported-external-systems',
        MIGRATED_TENANTS: 'back-office-migrated-tenants',
        MIGRATED_EXTERNAL_SYSTEMS: 'back-office-migrated-external-systems',
        COMPANIES: 'back-office-companies',
        KEY_INDICATE_USERS: 'back-office-key-indicate-users',
        ASSIGNABLE_TENANT_ROLES: 'back-office-assignable-tenant-roles',
        IMPORT_TENANT_CONFIG_OPTIONS: 'back-office-import-tenant-config-options',
        MIGRATE_TENANT_CONFIG_OPTIONS: 'back-office-migrate-tenant-config-options',
        IMPORT_INTEGRATION_CONFIG_OPTIONS: 'back-office-import-integration-config-options',
        MIGRATE_SYSTEM_CONFIG_OPTIONS: 'back-office-migrate-system-config-options',
        INTEGRATION_CONFIG_OPTIONS: 'back-office-integration-config-options',
        INTEGRATION_CONFIGS: 'back-office-integration-configs',
        INTEGRATION_CONFIG: 'back-office-integration-config',
        STREAMING_PROVIDER_OPTIONS: 'back-office-streaming-provider-options',
        STREAMING_CONFIGS: 'back-office-streaming-configs',
        STREAMING_CONFIG: 'back-office-streaming-config',
        STREAMING_TENANT_FILTER_OPTIONS: 'back-office-streaming-tenant-filter-options',
        EXTERNAL_SYSTEMS_FOR_TENANT: 'back-office-external-systems-for-tenant',
        SYNC_JOBS: 'back-office-sync-jobs',
        ASR_CONFIG_RULES: 'back-office-asr-config-rules',
        ASR_CONFIG_FILTER_OPTIONS: 'back-office-asr-config-filter-options',
        ASR_CONFIG_EXTERNAL_SYSTEMS: 'back-office-asr-config-external-systems',
        CATEGORIES: 'back-office-categories',
        RETENTION_SETTINGS: 'back-office-retention-settings',
        RETENTION_DATA_TYPES: 'back-office-retention-data-types',
        RETENTION_QUEUES_AND_SKILLS: 'back-office-retention-queues-and-skills',
        KEY_INDICATE_SYNC_SYSTEMS: 'back-office-key-indicate-sync-systems',
        KEY_INDICATE_SYNC_DATA_TYPES: 'back-office-key-indicate-sync-data-types',
        ASR_JOBS: 'back-office-asr-jobs',
        INTEGRATION_OVERVIEW: 'back-office-integration-overview',
        INTEGRATION_SYNC_JOBS: 'back-office-integration-sync-jobs',
        CSM_USERS: 'back-office-csm-users',
        SYSOP_USERS: 'back-office-sysop-users',
        AGENTS_WITHOUT_USER: 'back-office-agents-without-user',
        CREATE_USER_FROM_AGENT_JOBS: 'back-office-create-user-from-agent-jobs',
    },
} as const;
